import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=c42ec934&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c42ec934')) {
      api.createRecord('c42ec934', component.options)
    } else {
      api.reload('c42ec934', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=c42ec934&", function () {
      api.rerender('c42ec934', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UOs17CX217yi/JS/cancellationPolicy.vue"
export default component.exports